import * as React from 'react'
import styled from 'styled-components'

import GoogleLogin from '../GoogleLogin'

import GoogleContext from './../GoogleContext'

const DashboardHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`

const Title = styled.div`
  font-size: 2.125rem;
  line-height: 1.29;
  text-align: center;
  color: #4a4a4a;
`

const Home = () => (
  <DashboardHolder>
    <Title>Welcome to the Manager App 🙌</Title>
    <GoogleContext.Consumer>
      {({ SIGNIN_CLIENT_ID }) => <GoogleLogin clientId={SIGNIN_CLIENT_ID} />}
    </GoogleContext.Consumer>
  </DashboardHolder>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.tsx